// src/theme.js
import { extendTheme } from "@mui/joy/styles";
import { checkboxClasses } from "@mui/joy/Checkbox";

const customTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        danger: {
          500: "#FF4141", // 自定义错误状态颜色
        },
        divider: " rgb(244, 245, 247)",
        // divider: {
        //   lineColor: "red"
        // }
      },
    },
  },
  fontFamily: {
    // 设置全局字体
    body: "'Gilroy', sans-serif", // 替换为你的字体
    display: "'Gilroy', sans-serif", // 标题字体（可选）
  },
  components: {
    JoyDrawer: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.size === 'xl' && {
            '--Drawer-horizontalSize': '90vw',
            '--Drawer-verticalSize': '95vh'
          })
        }),
      },
      // defaultProps: {
      //   size: 'xl', // 设置默认尺寸
      // },
    },
    JoyCheckbox: {
      styleOverrides: {
        // 根容器样式
        root: {
          "--Checkbox-size": "20px", // 设置尺寸
          borderRadius: "6px", // 圆角
          display: "flex",
          alignItems: "center",
        },
        // 复选框本体样式
        checkbox: ({ ownerState }) => ({
          // 未选中状态
          backgroundColor: "#f0f0f0", // 浅灰背景
          borderColor: "#666", // 深灰边框
          borderRadius: "6px",

          // 选中状态
          [`.${checkboxClasses.checked} > &`]: {
            backgroundColor: "#ffd700", // 黄色背景
            borderColor: "#666", // 深灰边框
          },
          // 勾选图标样式
          [`.${checkboxClasses.checked} > & > svg`]: {
            color: "#000", // 黑色勾选图标
          },
          // 聚焦状态
          "&:focus-within": {
            boxShadow: "none",
            // boxShadow: "0 0 0 2px rgba(102, 102, 102, 0.3)", // 保留聚焦效果
          },
        }),
      },
    },
    JoyInput: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          borderRadius: "12px",
          // border: "1px solid #DFE5EB",
          backgroundColor: "#F1F2F3",
          fontWeight: "600",
          fontSize: "14px",
          "--Input-minHeight": "48px",
          "--Input-decoratorChildHeight": "48px",
        }),
        input: {
          "&::placeholder": {
            color: "#a0a0a0",
            fontSize: "16px",
            fontWeight: "600",
          },
        },
      },
    },

    JoyFormControl: {
      styleOverrides: {
        root: ({ theme }) => ({
          "--joy-palette-danger-500": "#FF4141",
          paddingBottom: "8px",
        }),
      },
    },
    JoyFormHelperText: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: "#FF4141",
          fontSize: "12px",
          fontWeight: "600",
          paddingLeft: "12px",
          marginTop: "5px",
        }),
      },
    },
  },
});

export default customTheme;
